import { Tooltip } from 'antd';
import React from 'react';
import { TimesheetEntryType } from 'api/timesheets';
import { useTranslate } from 'hooks/use-translation';
import { TimesheetWeeklyRowTask } from '../types';

export const isRowDeleted = (
  task: TimesheetWeeklyRowTask,
): { isDeleted: boolean; entity?: string } => {
  if (task?.project?.archived || task?.project?.deleted) {
    return { isDeleted: true, entity: 'project' };
  }
  if (task?.entryType === TimesheetEntryType.TaskEntry && task?.deleted) {
    return { isDeleted: true, entity: 'task' };
  }
  if (task?.entryType === TimesheetEntryType.PhaseEntry) {
    if (task?.projectPhase.deleted) {
      return { isDeleted: true, entity: 'phase' };
    }
  }

  return { isDeleted: false };
};

export const RowWithTooltip = ({ children, tableType, ...restProps }) => {
  const translate = useTranslate();

  const getTooltipText = (type?: string): string => {
    let tooltipText = '';

    if (type === 'project') {
      tooltipText = translate('timesheets.project_deleted.tooltip');
    } else if (type === 'phase') {
      tooltipText = translate('timesheets.phase_deleted.tooltip');
    } else {
      tooltipText = translate('timesheets.task_deleted.tooltip');
    }

    if (tableType === 'entry-table') {
      tooltipText = tooltipText
        .concat(' ')
        .concat(translate('timesheets.no_further_edits.tooltip'));
    }

    return tooltipText;
  };

  const task = isRowDeleted(children[0]?.props.record.task);

  return (
    <Tooltip title={task.isDeleted ? getTooltipText(task.entity) : ''}>
      <tr {...restProps}>{children}</tr>
    </Tooltip>
  );
};
